module.exports = __webpack_public_path__ + "media/images/elit-2bd5a82058b66f13b4748e43f4defa3c.png";